import React from 'react'
import "./footer.css"
import { FaGithub, FaHackerrank, FaHome, FaInstagram, FaLinkedin, FaMailBulk, FaMedium, FaPhone } from "react-icons/fa"
import { Link } from 'react-router-dom'
function Footer() {
    return (
        <div className='footer'>
            <div className='footer-container'>
                <div className='left'>
                    <div className='location'>
                        <FaHome size={25} style={{ color: 'orange', marginRight: "1.5rem" }} />
                        <div>
                            <p>Istanbul / Turkey</p>
                        </div>
                    </div>
                    <div className='phone'>
                        <h4>
                            <FaPhone size={25} style={{ color: 'orange', marginRight: "1.5rem" }} />
                            +90-542-797-84-42
                        </h4>
                    </div>
                    <div className='email'>
                        <h4>
                            <FaMailBulk size={25} style={{ color: 'orange', marginRight: "1.5rem" }} />
                            berk.tenkoglu@gmail.com
                        </h4>
                    </div>
                </div>
                <div className='right'>
                    <h4>
                        About me
                    </h4>
                    <p>
                        This is Berk Tenkoğlu.</p>
                    <p>
                        Cyber Security Consultant with a Frontend Development Background

                        Passionate about building secure, responsive web applications and continuously expanding expertise in modern web technologies, application security, and API protection.
                    </p>
                    <div className='social'>

                        <Link to={"https://github.com/BerkTenk"}><FaGithub size={25} style={{ color: 'orange', marginRight: "1.5rem" }} /></Link>
                        <Link to={"https://www.instagram.com/berktenkoglu"}><FaInstagram size={25} style={{ color: 'orange', marginRight: "1.5rem" }} /></Link>
                        <Link to={"https://www.linkedin.com/in/berktenkoglu"}><FaLinkedin size={25} style={{ color: 'orange', marginRight: "1.5rem" }} /></Link>
                        <Link to={"https://www.hackerrank.com/profile/berk_tenkoglu"}><FaHackerrank size={25} style={{ color: 'orange', marginRight: "1.5rem" }} /></Link>
                        <Link to={"https://medium.com/@berk.tenkoglu"}><FaMedium size={25} style={{ color: 'orange', marginRight: "1.5rem" }} /></Link>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer